<template>
    <div class="col-md-12">
        <div class="field pull-right">
            <div class="control">
                <button class="btn btn-success" title="Add New Product" type="button" @click="add">
                    <span class="icon"><i class="fas fa-plus"></i></span><span> Add New Product</span>
                </button>
            </div>
        </div>
        <br>
        <br>
        <hr>
        <table v-cloak v-if="data.length" class="table is-narrow is-striped is-fullwidth">
            <thead>
                <tr>
                    <th>Products</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item, key) in data">
                    <td>
                        <input v-model="item.name" :name="'products[' + key + '][name]'" class="form-control" placeholder="Product Name" required type="text">
                        <table v-cloak v-if="item.ad_sizes.length" class="table is-narrow is-striped is-fullwidth">
                            <thead>
                                <tr>
                                    <th style="width: 10%"></th>
                                    <th style="width: 20%">Ad Size</th>
                                    <th style="width: 60%">Description</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="ad_size in item.ad_sizes">
                                    <td style="width: 10%"></td>
                                    <td style="width: 20%">
                                        <a :href="ad_size.route" v-html="ad_size.name"></a>
                                    </td>
                                    <td style="width: 60%">
                                        <span v-html="ad_size.truncated_description"></span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </td>
                    <td style="padding: 2px;">
                        <button class="btn btn-danger" title="Remove Product" type="button" @click="remove(key)">
                            <span class="icon"><i class="fas fa-trash"></i></span>
                        </button>
                        <input v-model="item.id" :name="'products[' + key + '][id]'" type="hidden">
                    </td>
                </tr>
            </tbody>
        </table>
        <div v-cloak v-else>
            <p>No Products Found. <a href="javascript:" @click="add">Add One Now</a></p>
        </div>
    </div>
</template>

<script>
    const emptyProduct = {
        id: null,
        name: null,
        ad_sizes: []
    };

    export default {
        name: 'AdvertisingProducts',
        props: {
            data: {
                type: Array,
                default() {
                    return [];
                }
            }
        },
        methods: {
            add() {
                this.data.push(structuredClone(emptyProduct));
                this.$nextTick(() => {
                    this.$forceUpdate();
                });
            },
            remove(index) {
                if(confirm('Are you sure you want to remove this product?')) {
                    this.$delete(this.data, index);
                    this.$nextTick(() => {
                        this.$forceUpdate();
                    });
                }
            }
        }
    };
</script>
